import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import loggingMiddleware from './middlewares/loggingMiddleware';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle

const configureStore = () => createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(thunkMiddleware, loggingMiddleware),
    ),
);

export default configureStore;
